import React, { useState } from 'react';
import WhatsAppPage from './WhatsAppPage';
import WhatsAppContactsPage from './WhatsAppContactsPage';
import WhatsAppTemplatesPage from './WhatsAppTemplatesPage';
import WhatsAppCampaignsPage from './WhatsAppCampaignsPage';
import WhatsAppAutoReplyPage from './WhatsAppAutoReplyPage';
import WhatsAppInboxPage from './WhatsAppInboxPage';
import WhatsAppFlowsPage from './WhatsAppFlowsPage';
import WhatsAppLeadFormsPage from './WhatsAppLeadFormsPage';
import WhatsAppApiKeysPage from './WhatsAppApiKeysPage';
import WhatsAppInteractiveFlowsPage from './WhatsAppInteractiveFlowsPage';
import WhatsAppAnalyticsPage from './WhatsAppAnalyticsPage';

// WhatsAppHubPage consolidates 11 separate WhatsApp pages into one workspace
// with internal tabs. Mirrors the PharmacyPage / ClinicalPage / PayrollHubPage
// pattern. Legacy hub keys (wa-contacts, wa-templates, ...) still resolve
// here via `initialTab`.
const WA_TABS = [
  { key: 'cloud',       label: 'Cloud',         render: (props) => <WhatsAppPage {...props} /> },
  { key: 'inbox',       label: 'Live Inbox',    render: () => <WhatsAppInboxPage /> },
  { key: 'contacts',    label: 'Contacts',      render: () => <WhatsAppContactsPage /> },
  { key: 'templates',   label: 'Templates',     render: () => <WhatsAppTemplatesPage /> },
  { key: 'campaigns',   label: 'Campaigns',     render: () => <WhatsAppCampaignsPage /> },
  { key: 'autoreply',   label: 'Auto-Reply',    render: () => <WhatsAppAutoReplyPage /> },
  { key: 'flows',       label: 'Chatbot Flows', render: () => <WhatsAppFlowsPage /> },
  { key: 'forms',       label: 'Lead Forms',    render: () => <WhatsAppLeadFormsPage /> },
  { key: 'interactive', label: 'Interactive Flows', render: () => <WhatsAppInteractiveFlowsPage /> },
  { key: 'analytics',   label: 'Analytics',     render: () => <WhatsAppAnalyticsPage /> },
  { key: 'api-keys',    label: 'API Keys',      render: () => <WhatsAppApiKeysPage /> },
];

const LEGACY_MAP = {
  'whatsapp':              'cloud',
  'wa-inbox':              'inbox',
  'wa-contacts':           'contacts',
  'wa-templates':          'templates',
  'wa-campaigns':          'campaigns',
  'wa-autoreply':          'autoreply',
  'wa-flows':              'flows',
  'wa-forms':              'forms',
  'wa-interactive-flows':  'interactive',
  'wa-analytics':          'analytics',
  'wa-api-keys':           'api-keys',
};

const WhatsAppHubPage = ({ API_BASE, patientsList, initialTab = 'cloud' }) => {
  const [tab, setTab] = useState(LEGACY_MAP[initialTab] || initialTab);
  const Active = WA_TABS.find(t => t.key === tab) || WA_TABS[0];

  return (
    <div>
      <div style={{ display: 'flex', gap: 6, marginBottom: 16, flexWrap: 'wrap' }}>
        {WA_TABS.map(t => (
          <button key={t.key} onClick={() => setTab(t.key)}
            style={{
              padding: '8px 16px', borderRadius: 8, border: 'none', cursor: 'pointer',
              fontWeight: 600, fontSize: '0.82rem',
              backgroundColor: tab === t.key ? '#16A34A' : '#e9ecef',
              color: tab === t.key ? 'white' : '#555',
            }}>
            {t.label}
          </button>
        ))}
      </div>
      {Active.render({ API_BASE, patientsList })}
    </div>
  );
};

export default WhatsAppHubPage;
